import { Controller } from "@hotwired/stimulus"

// Controls the responsive sidebar panel and backdrop on mobile
export default class extends Controller {
  static targets = ["panel", "overlay"]

  connect() {
    // Ensure initial state is closed on small screens
    this.isOpen = false
    this.update()
  }

  toggle() {
    this.isOpen = !this.isOpen
    this.update()
  }

  open() {
    this.isOpen = true
    this.update()
  }

  close() {
    this.isOpen = false
    this.update()
  }

  onKeyup(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.close()
    }
  }

  update() {
    const panel = this.panelTarget
    const overlay = this.overlayTarget

    if (this.isOpen) {
      panel.classList.remove("-translate-x-full")
      overlay.classList.remove("opacity-0", "pointer-events-none")
    } else {
      panel.classList.add("-translate-x-full")
      overlay.classList.add("opacity-0", "pointer-events-none")
    }
  }
}
